import { render, staticRenderFns } from "./regLogin.vue?vue&type=template&id=00d53730&scoped=true&"
import script from "./regLogin.vue?vue&type=script&lang=js&"
export * from "./regLogin.vue?vue&type=script&lang=js&"
import style0 from "./regLogin.vue?vue&type=style&index=0&id=00d53730&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d53730",
  null
  
)

export default component.exports